<div class="heading-container">
  <h2 class="error-heading"><mat-icon>error</mat-icon>Error</h2>
</div>

<div class="dialog-content-center">
    <p style="white-space: pre-wrap">{{errorMessage}}</p>
</div>
<mat-dialog-actions align="center" class="dialog-button-container">
    <button class="dialog-button" mat-raised-button (click)="onOkayClick()" color="primary">Okay</button>
</mat-dialog-actions>
